// anime.js - https://animejs.com/
import anime from 'animejs/lib/anime.es.js';

const initialiseGirl = () => {
  let timelineGirl = anime.timeline({
    autoplay: true,
    duration: 5500,
    direction: 'alternate',
    loop: true,
    easing: 'easeInOutSine',
  });

  timelineGirl.add({
    targets: '.illustration--girl',
    left: [150, 250, 350],
    bottom: [210, 50, 150],
    scale: [1, 0.9, 0.8],
  });
};

exports.initialiseGirl = initialiseGirl;
